import ContainersPerMonth from "../Widget.ContainersPerMonth/Widget.ContainersPerMonth";
import TEUByMonth from "../Widget.TEUByMonth/Widget.TEUByMonth";
import MonthlyWeightShipped from "../Widget.MonthlyWeightShipped/Widget.MonthlyWeightShipped";
import ShipmentsPerDay from "../Widget.ShipmentsPerDay/Widget.ShipmentsPerDay";
import TopInTransitLanes from "../Widget.TopInTransitLanes/Widget.TopInTransitLanes";
import OnTimeArrival from "../Widget.OnTimeArrival/Widget.OnTimeArrival";
import ContainersByDestinationRegion from "../Widget.ContainersByDestinationRegion/Widget.ContainersByDestinationRegion";
import ModeOfTransportationBreakdownByMonth from "../Widget.ModeOfTransportationBreakdownByMonth/Widget.ModeOfTransportationBreakdownByMonth";
import OnTimeDeparture from "../Widget.OnTimeDeparture/Widget.OnTimeDeparture";
import ShipmentsAndContainersByIncoTerm from "../Widget.ShipmentsAndContainersByIncoTerm/Widget.ShipmentsAndContainersByIncoTerm";
import DrayMovesByCarrierAndOriginLocation from "../Widget.DrayMovesByCarrierAndOriginLocation/Widget.DrayMovesByCarrierAndOriginLocation";
import RollCounterByShipmentsAndContainers from "../Widget.RollCounterByShipmentsAndContainers/Widget.RollCounterByShipmentsAndContainers";
import OnTimeDocumentPerMonth from "../Widget.OnTimeDocumentPerMonth/Widget.OnTimeDocumentPerMonth";

const Widgets = {
  ContainersPerMonth,
  TEUByMonth,
  MonthlyWeightShipped,
  ShipmentsPerDay,
  TopInTransitLanes,
  ContainersByDestinationRegion,
  OnTimeArrival,
  ModeOfTransportationBreakdownByMonth,
  OnTimeDeparture,
  ShipmentsAndContainersByIncoTerm,
  DrayMovesByCarrierAndOriginLocation,
  RollCounterByShipmentsAndContainers,
  OnTimeDocumentPerMonth
}

export default Widgets;
